import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, unref as _unref } from "vue"

const _hoisted_1 = { class: "page" }
const _hoisted_2 = {
  style: {"box-shadow":"1px 1px 16.4px 0px #94a3b829","backdrop-filter":"blur(8px)"},
  class: "main"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "title" }
const _hoisted_5 = {
  key: 1,
  class: "coin"
}
const _hoisted_6 = ["src"]
const _hoisted_7 = {
  key: 2,
  class: "chain"
}
const _hoisted_8 = { class: "chainIte" }
const _hoisted_9 = { class: "cityIntro" }

import useDownloadApp from '@/hooks/useDownloadApp';
import Header from '@/components/header.vue';
import i18n from '@/language';
import { useClipboard, useDark } from '@vueuse/core';
import { message } from 'ant-design-vue';
import { computed, onMounted, ref, watchEffect } from 'vue';
import { useRoute } from 'vue-router';
import useOpenApp from '@/hooks/useOpenApp';
import { getCityDetail } from '@/api/live';


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const route = useRoute();

const code = computed(() => route.query?.id as string);

const { downloadApp } = useDownloadApp();

const { openApp } = useOpenApp();

const cityDetail = ref<any>();
const getcityDetailApi = async () => {
  try {
    let res = await getCityDetail({
      cityId: route.query.id,
    });
    if (res.value.code == 0) {
      cityDetail.value = res.value.result;
      cityDetail.value.symbols =
        res.value.result.symbols && res.value.result.symbols.slice(0, 2);
      cityDetail.value.chainNames =
        res.value.result.chainNames && res.value.result.chainNames.slice(0, 2);
    }
  } catch (error) {}
};

const isDark = useDark({
  selector: 'html',
  attribute: 'data-theme',
  valueDark: 'dark',
  valueLight: 'light',
});

const { copy, copied } = useClipboard({});

watchEffect(() => {
  if (copied.value) {
    // @ts-ignore
    message.success(i18n.global.t('复制成功'));
  }
});

onMounted(() => {
  if (route.query?.id) {
    openApp();
  }
  getcityDetailApi();
  if (route.query.theme === 'dark') {
    isDark.value = true;
  } else {
    isDark.value = false;
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Header),
    _createElementVNode("div", _hoisted_2, [
      (cityDetail.value)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            class: "tx",
            src: cityDetail.value.logo
          }, null, 8, _hoisted_3))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, _toDisplayString((cityDetail.value && cityDetail.value.cityName) || '-'), 1),
      (cityDetail.value && cityDetail.value.symbols && cityDetail.value.symbols.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cityDetail.value.symbols, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "coinItem",
                key: index
              }, [
                _createElementVNode("img", {
                  src: item.logo
                }, null, 8, _hoisted_6),
                _createTextVNode(" " + _toDisplayString(item.symbol), 1)
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      (
          cityDetail.value && cityDetail.value.chainNames && cityDetail.value.chainNames.length
        )
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cityDetail.value.chainNames, (item, index) => {
              return (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(item), 1))
            }), 256))
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_9, _toDisplayString(cityDetail.value?.cityIntro || '-'), 1),
      _createElementVNode("div", {
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(openApp) && _unref(openApp)(...args))),
        class: "btnBox"
      }, _toDisplayString(_ctx.$t('前往City')), 1),
      _createElementVNode("div", {
        class: "tip",
        onClick: _cache[1] || (_cache[1] = 
          () => {
            _unref(downloadApp)();
          }
        )
      }, [
        _createTextVNode(_toDisplayString(_ctx.$t('在此设备首次使用Envo?')), 1),
        _createElementVNode("span", null, _toDisplayString(_ctx.$t('下载 Envo')), 1)
      ])
    ])
  ]))
}
}

})